import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import './registerServiceWorker'

import VueFire from 'vuefire'

import Icon from 'buefy'
import Tabs from 'buefy'
import Button from 'buefy'
import Tag from 'buefy'
import Input from 'buefy'
import Modal from 'buefy'
import Notification from 'buefy'
import Navbar from 'buefy'
import Dropdown from 'buefy'
import Switch from 'buefy'
import Select from 'buefy'
import Checkbox from 'buefy'
import Loading from 'buefy'
import Field from 'buefy'
import Dialog from 'buefy'
import { ToastProgrammatic as Toast } from 'buefy'
import Tooltip from 'buefy'
import Table from 'buefy'
import Message from 'buefy'
import { SnackbarProgrammatic as Snackbar } from 'buefy'

Vue.use(VueFire)

Vue.use(Button)
Vue.use(Icon)
Vue.use(Dropdown)
Vue.use(Modal)
Vue.use(Loading)
Vue.use(Field)
Vue.use(Toast)
Vue.use(Dialog)
Vue.use(Table)
Vue.use(Tabs)
Vue.use(Navbar)
Vue.use(Input)
Vue.use(Switch)
Vue.use(Checkbox)
Vue.use(Select)
Vue.use(Tooltip)
Vue.use(Message)
Vue.use(Tag)
Vue.use(Notification)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

//Store subscriptions
store.subscribe((mutation, state) => {


  //Mutations to store in history
  var historyMutations= ['SET_ITEMS','ADD_ITEM','ADD_GROUP','REMOVE_ITEM','ADD_GROUP','REMOVE_GROUP', 'SET_SLOT_STATUS','UPDATE_SETTING','UPDATE_ADDONS', 'MOVE_ITEM', 'MOVE_GROUP'];

  if(typeof state.history !== 'undefined' && state.history.mode === 'record'){

    //Notification for group removal mutation
    if(mutation.type === 'REMOVE_GROUP'){
      Toast.open({message:'Removed group', position:'is-bottom-right', type:'is-dark', queue:false});
    }

    //Notification for lock mechanism mutation
    if(mutation.type === 'SET_SLOT_STATUS'){
      var type = (mutation.payload.value)?'is-white':'is-dark';
      Toast.open({message:mutation.payload.message, position:'is-bottom', type, queue:false});
    }

    //Notification for lock mechanism mutation
    if(mutation.type === 'SET_ITEMS'){
    setTimeout(() => {
      Toast.open({message:'LOADED SAVED ITEMS', position:'is-bottom', type, queue:false});
    }, 1300);
    }


    //Add mutation to history array
    if(!state.app.isLoading && historyMutations.includes(mutation.type) && (!mutation.payload.hasOwnProperty('noHistory') || !mutation.payload.noHistory)){
    
      state.history.mutations.push(JSON.stringify(mutation));
     
    }
       

  }
  
  if(!state.app.isLoading && historyMutations.includes(mutation.type)){
    store.commit('SAVE_CONFIGURATION_STATE');
    }
  


})
